<div class="loader" [ngClass]="{'loader-sm':loaderSize === 'small', 'loader-md':loaderSize === 'medium','loader-lg':loaderSize === 'large'}">
</div>
